module.exports = {"TXTWCL_Stake":{"id":"TXTWCL_Stake","defaultMessage":"Stake","track":"Stake"}}